import axios from 'axios';

let prefix = "/global-setting"

const GlobalSettingApi = {
	
	getEnergySetting(payload){
		return axios.get( prefix + "/energy-setting", {params: payload})
	},
	updateEnergySetting(payload){
		return axios.post( prefix + "/update-energy-setting", payload)
	},

	getHeroLevelSetting(payload) {
		return axios.get(prefix + "/hero-level-setting", { params: payload });
	},
	updateHeroLevelSetting(payload) {
		return axios.post(prefix + "/update-hero-level-setting", payload);
	},
	getHeroSkillLevelSetting(payload) {
		return axios.get(prefix + "/hero-skill-level-setting", { params: payload });
	},
	updateHeroSkillLevelSetting(payload) {
		return axios.post(prefix + "/update-hero-skill-level-setting", payload);
	},
	getFarmingBaseValueSetting(payload) {
		return axios.get(prefix + "/farming-base-value-setting", { params: payload });
	},
	updateFarmingBaseValueSetting(payload) {
		return axios.post(prefix + "/update-farming-base-value-setting", payload);
	},
	getRarityModifierSetting(payload) {
		return axios.get(prefix + "/rarity-modifier", { params: payload });
	},
	updateRarityModifierSetting(payload) {
		return axios.post(prefix + "/update-rarity-modifier", payload);
	},
	getHeroGroup(payload) {
		return axios.get(prefix + "/hero-group", { params: payload });
	},
	createHeroGroup(payload) {
		return axios.post(prefix + "/create-hero-group", payload);
	},
	updateHeroGroup(payload) {
		return axios.post(prefix + "/update-hero-group", payload);
	},
	deleteHeroGroup(payload) {
		return axios.delete(prefix + "/delete-hero-group", { params: payload });
	},
	getHeroSkillLevelCosts(payload) {
		return axios.get(prefix + "/hero-skill-level-costs", { params: payload });
	},
	createHeroSkillLevelCost(payload) {
		return axios.post(prefix + "/create-hero-skill-level-cost", payload);
	},
	updateHeroSkillLevelCost(payload) {
		return axios.post(prefix + "/update-hero-skill-level-cost", payload);
	},
	deleteHeroSkillLevelCost(payload) {
		return axios.delete(prefix + "/delete-hero-skill-level-cost", { params: payload });
	},
	getCurrencyExchangeRates(payload) {
		return axios.get(prefix + "/currency-exchange-rates", { params: payload });
	},
	createCurrencyExchangeRate(payload) {
		return axios.post(prefix + "/create-currency-exchange-rate", payload);
	},
	updateCurrencyExchangeRate(payload) {
		return axios.post(prefix + "/update-currency-exchange-rate", payload);
	},
	getGoogleSheetUrls(payload) {
		return axios.get(prefix + "/google-sheet-urls", { params: payload });
	},
	updateGoogleSheetUrls(payload) {
		return axios.post(prefix + "/update-google-sheet-urls", payload);
	},
	getStarUpgradeCost(payload) {
		return axios.get(prefix + "/star-upgrade-cost", { params: payload });
	},
	updateStarUpgradeCost(payload) {
		return axios.post(prefix + "/update-star-upgrade-cost", payload);
	},
	getMaxEssenceSetting(payload) {
		return axios.get(prefix + "/max-essence-setting", { params: payload });
	},
	updateMaxEssenceSetting(payload) {
		return axios.post(prefix + "/update-max-essence-setting", payload);
	},
	getRegistrationBonusSetting(payload) {
		return axios.get(prefix + "/registration-bonus-setting", { params: payload });
	},
	updateRegistrationBonusSetting(payload) {
		return axios.post(prefix + "/update-registration-bonus-setting", payload);
	},
	deleteRegistrationBonusSetting(payload) {
		return axios.delete(prefix + "/delete-registration-bonus-setting", { params: payload });
	},

}

export default GlobalSettingApi;